import { render } from "./DmWeightTargetsPage.vue?vue&type=template&id=70745797&scoped=true"
import script from "./DmWeightTargetsPage.vue?vue&type=script&lang=js"
export * from "./DmWeightTargetsPage.vue?vue&type=script&lang=js"

import "./DmWeightTargetsPage.vue?vue&type=style&index=0&id=70745797&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\loop Company\\Apps\\cms-dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70745797"]])

export default __exports__